export default __webpack_public_path__ + "static/media/mainpic1.0baac898.png";